import { useTranslation } from 'react-i18next';
import { Stack } from '@mui/material';
import ToggleButtonGroupField from '../fields/toggle-button-group-field/toggle-button-group-field.component';
import AddCustomRuleSelectProducts from './add-custom-rule-select-products/add-custom-rule-select-products.component';
import AddCustomRuleSelectRecommendation from './add-custom-rule-select-recommendation/add-custom-rule-select-recommendation.component';
import AddCustomRuleField from './add-custom-rule-field/add-custom-rule-field.component';

const AddCustomRuleForm = () => {
  const { t } = useTranslation();

  const options = [
    {
      label: t('forms.addCustomRuleForm.anyAllToggler.options.any'),
      value: 'OR',
    },
    {
      label: t('forms.addCustomRuleForm.anyAllToggler.options.all'),
      value: 'AND',
    },
  ];

  return (
    <Stack gap={2}>
      <AddCustomRuleField
        label={t('forms.addCustomRuleForm.anyAllToggler.label')}
      >
        <ToggleButtonGroupField
          name="ruleType"
          exclusive
          fullWidth
          options={options}
        />
      </AddCustomRuleField>
      <AddCustomRuleField
        label={t('forms.addCustomRuleForm.selectProducts.label')}
      >
        <AddCustomRuleSelectProducts />
      </AddCustomRuleField>
      <AddCustomRuleField
        label={t('forms.addCustomRuleForm.recommendations.label')}
      >
        <AddCustomRuleSelectRecommendation />
      </AddCustomRuleField>
    </Stack>
  );
};

export default AddCustomRuleForm;
